import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-audio-viewer',
  templateUrl: './audio-viewer.component.html',
  styleUrls: ['./audio-viewer.component.css']
})
export class AudioViewerComponent implements OnInit {
  @Input() src: string = '';
  constructor() { }

  ngOnInit(): void {
  }

}
